import Vue from 'vue'

// // v-dialogDrag: 弹窗拖拽   需要限制拖拽范围
Vue.directive('dialogDrag', {
    bind(el, binding, vnode, oldVnode) {
        const dialogHeaderEl = el.querySelector('.el-dialog__header');
        const dragDom = el.querySelector('.el-dialog');
        const dialogwrapper = el.querySelector('.el-dialog__wrapper');
        // console.dir(document.getElementById('content').clientWidth);
        if (dialogHeaderEl) {
            dialogHeaderEl.style.cursor = 'move';
            // console.log(dialogHeaderEl);
            // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
            // console.log(dragDom.currentStyle)  
            let sty;
            if (dragDom) {
                sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
            }
            dialogHeaderEl.onmousedown = (e) => {
                // 鼠标按下，计算当前元素距离可视区的距离
                const disX = e.clientX - dialogHeaderEl.offsetLeft;
                const disY = e.clientY - dialogHeaderEl.offsetTop;
                // 获取到的值带px 正则匹配替换
                let styL, styT;
                // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px   兼容处理
                if (sty.left.includes('%')) {
                    styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
                    styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
                } else {
                    styL = +sty.left.replace(/\px/g, '');
                    styT = +sty.top.replace(/\px/g, '');
                };

                document.onmousemove = function(e) {
                    // 通过事件委托，计算移动的距离 
                    const l = e.clientX - disX;
                    const t = e.clientY - disY;

                    // 移动当前元素  x=>-140px  y=>-340px;
                    if (l + styL <= 10) {
                        dragDom.style.left = `10px`;
                    } else if (l + styL >= document.body.clientWidth) {
                        dragDom.style.left = `${document.body.clientWidth}px`;
                    } else {
                        dragDom.style.left = `${l + styL}px`;
                    }

                    if (t + styT <= 10) {
                        dragDom.style.top = `10px`;
                    } else if (t + styT >= document.body.clientHeight) {
                        dragDom.style.top = `${document.body.clientHeight}px`;
                    } else {
                        dragDom.style.top = `${t + styT}px`;
                    }

                    //将此时的位置传出去
                    //binding.value({x:e.pageX,y:e.pageY})
                };
                document.onmouseup = function(e) {
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
            }
        }
    }
})


// WEBPACK FOOTER //
// ./src/tools/dialogDrag.js